<template>
  <div>
    <Divider orientation="left">客户消费</Divider>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1">消费数据</Col>
      <Col flex="2">稳定性评级:<span class="bold-p"> {{ boardData.payoutStabilityRating }}</span></Col>
      <Col flex="2">月均支出:<span
        class="bold-p"> ¥{{ homeStat.summary_metrics.payoutMonthAvg }}元</span></Col>
    </Row>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1"></Col>
      <Col flex="2">近3个月均消费:{{ boardData.payoutLastThreeMonths }}元</Col>
      <Col flex="2">近6个月均消费:{{ boardData.payoutLastSixMonths }}元</Col>
    </Row>
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>提供客户消费能力与消费数据，依据客户日常消费数据，判断客户收入能力，近三个月和六个月不包括转账</p>
        <p>稳定性分为高/中/低,依次变差，近3个月按照近90天,近6个月按照近180天取数，下同</p>
      </Card>
    </Row>
    <Divider orientation="left">客户收入</Divider>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1">收入数据</Col>
      <Col flex="2">月均工资: {{ homeStat.incoming.wages.monthAvg }}，{{ homeStat.incoming.wages.countData }}个月</Col>
      <Col flex="2">月均收单: {{ homeStat.incoming.posTrade.monthAvg }}，{{ homeStat.incoming.posTrade.countData }}个月</Col>
      <Col flex="2">月均收入:<span
        class="bold-p"> ¥{{ homeStat.summary_metrics.incomingMonthAvg}}元</span></Col>
    </Row>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1"></Col>
      <Col flex="2">近3个月均收入:{{ boardData.incomeLastThreeMonths }}元</Col>
      <Col flex="2">近6个月均收入:{{ boardData.incomeLastSixMonths }}元</Col>
      <Col flex="2">稳定性评级:<span class="bold-p"> {{ boardData.incomeStabilityRating }}</span></Col>
    </Row>
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>个人客户主要是工资，小微商户主要是收单收入，近三个月和六个月不包括转账</p>
      </Card>
    </Row>
    <Divider orientation="left">客户资产</Divider>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1">日均资产</Col>
      <Col flex="2">稳定性评级: <span class="bold-p">{{ boardData.assetDataStabilityRating }}</span></Col>
      <Col flex="2">日均资产:<span
        class="bold-p font-big-data"> ¥{{ homeStat.summary_metrics.assetDayAvg }}元</span></Col>
    </Row>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1"></Col>
      <Col flex="2">近3个月日均:{{ boardData.assetDataThreeMonthDayAvg }}元</Col>
      <Col flex="2">近6个月日均:{{ boardData.assetDataSixMonthDayAvg }}元</Col>
    </Row>
<!--    <Row class="content-board-row">-->
<!--      <Col flex="1">结息金额:{{ boardData.settlementTotalMoney }}元</Col>-->
<!--      <Col flex="1">可校验金额:{{boardData.validSettlementTotalMoney}}元</Col>-->
<!--      <Col flex="1">平均偏差率:{{boardData.averageDeviationRate}}%</Col>-->
<!--    </Row>-->
<!--    <Row class="content-board-row" v-for='settlement in boardData.settlementMapList'>-->
<!--      <Col flex="1">结息日期:{{settlement.statTime}}</Col>-->
<!--      <Col flex="1">金额:{{settlement.money}}元</Col>-->
<!--      <Col flex="1">利率:{{settlement.yearAvg}}%</Col>-->
<!--      <Col flex="1">计算结息:{{settlement.monthAvg}}元</Col>-->
<!--      <Col flex="1">偏差率:{{settlement.dayAvg}}%</Col>-->
<!--    </Row>-->
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>提供客户的银行卡余额日均情况，辅助证明客户的日常资产是否能否覆盖贷款额</p>
      </Card>
    </Row>
    <Divider orientation="left">账单校验</Divider>
    <Table border highlight-row :columns="uploadColumns" :data="dataMap.uploadLog"></Table>
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>微信和支付宝以及部分银行卡支持电子签名校验，如果电子签名校验失败肯定文件被改动过</p>
        <p>
          银行卡会进行余额连续性校验，即每笔交易金额是不是等于下一笔余额，极少银行交易排序不准确可能存在异常校验，详情有具体异常交易流水可以进行核验</p>
      </Card>
    </Row>
    <Divider orientation="left">司法涉诉校验</Divider>
    <Row class="content-board-row">
      <Col class="bold-p" flex="1">司法校验</Col>
      <Col flex="2">涉及金额: ¥{{ homeStat.blackTrade.judicialFreeze.money }}元</Col>
      <Col flex="2">校验结果: <span
        class="bold-p">{{ getJudicialFreezeResult(homeStat.blackTrade.judicialFreeze.money) }}</span></Col>
    </Row>
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>判断微信或者支付宝以及银行账单中是否存在司法冻结或者司法解冻的情况，如果存在表明已经存在严重逾期</p>
      </Card>
    </Row>
    <Divider orientation="left">不良嗜好校验</Divider>
    <Row class="content-board-row">
      <Col class="content-board-col bold-p" flex="1">娱乐校验</Col>
      <Col flex="2">涉及金额: ¥{{ homeStat.blackTrade.leisureEntertainment.money }}元</Col>
      <Col flex="2">校验结果: <span
        class="bold-p">{{ getBlackTradeResult(homeStat.blackTrade.leisureEntertainment.money) }}</span></Col>
    </Row>
    <Row class="content-board-row">
      <Col class="content-board-col bold-p" flex="1">高频转账</Col>
      <Col flex="2">涉及金额: ¥{{ homeStat.blackTrade.highFrequencyTransfer.money }}元</Col>
      <Col flex="2">校验结果: <span
        class="bold-p">{{ getBlackTradeResult(homeStat.blackTrade.highFrequencyTransfer.money) }}</span></Col>
    </Row>
    <Row class="content-board-row">
      <Col class="content-board-col bold-p" flex="1">夜间交易</Col>
      <Col flex="2">涉及金额: ¥{{ homeStat.blackTrade.nightTradeList.money }}元</Col>
      <Col flex="2">校验结果: <span
        class="bold-p">{{ getBlackTradeResult(homeStat.blackTrade.nightTradeList.money) }}</span></Col>
    </Row>
    <Row class="content-board-card">
      <Card :bordered="false" style="width: 100%">
        <p class="bold-p">策略描述</p>
        <p>不良嗜好识别数据，展示客户行为情况</p>
        <p><span class="bold-p">娱乐交易:</span>消费中KTV/会所等相关信息的所有支出且金额大于500，辅助判断客户是否存在黄赌情况
        </p>
        <p><span class="bold-p">高频转账:</span>一天内转同一对象账超过五次金额，辅助判断客户是否存在关联交易和赌博情况</p>
        <p><span class="bold-p">夜间交易:</span>晚上24点到早上5点之间交易，少量可以忽略大量查看是否匹配行业，辅助判断客户是否存在赌博情况
        </p>
      </Card>
    </Row>
  </div>
</template>
<script>

export default {

  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object
  },
  data () {
    return {
      uploadColumns:
        [{
          title: '账单类型',
          key: 'billType'
        }, {
          title: '姓名',
          key: 'name'
        }, {
          title: '账户',
          key: 'bankCardNo'
        }, {
          title: '文件',
          key: 'fileName'
        }, {
          title: '上传时间',
          key: 'uploadTime'
        }, {
          title: '电子签校验',
          key: 'signNums',
          render: (h, params) => {
            return h('div', [
              h('strong', params.row.signNums)
            ])
          }
        }, {
          title: '余额连续性校验',
          key: 'continuity',
          render: (h, params) => {
            return h('div', [
              h('strong', params.row.continuity)
            ])
          }
        }]
    }
  },
  mounted () {
    console.log(this.homeStat)
  },
  methods: {
    setData (dataMap, homeStat) {
      this.dataMap = dataMap
      this.homeStat = homeStat
    },
    getJudicialFreezeResult (money) {
      if (money === '0') {
        return '通过'
      } else {
        return '存在司法交易,建议拒绝'
      }
    },
    getBlackTradeResult (money) {
      if (money === '0') {
        return '通过'
      } else {
        return '存在,请重点关注'
      }
    },

    getBlackTradeResultOne (money) {
      if (money === '0') {
        return ''
      } else {
        return '1'
      }
    },
    getIncomeMoney (incoming, payout) {
      let money = 0
      if (incoming.wages) {
        money += Number(incoming.wages.monthAvg)
      }
      if (incoming.posTrade) {
        money += Number(incoming.posTrade.monthAvg)
      }
      if (incoming.transfer) {
        money += Number(incoming.transfer.monthAvg)
      }
      if (payout.transfer) {
        money = money - Number(payout.transfer.monthAvg)
      }
      return money
    },
    getPayoutMoney (data) {
      let money = 0
      if (data.other) {
        money += Number(data.other.monthAvg)
      }
      if (data.restaurant) {
        money += Number(data.restaurant.monthAvg)
      }
      if (data.buy) {
        money += Number(data.buy.monthAvg)
      }
      if (data.car) {
        money += Number(data.car.monthAvg)
      }
      if (data.phone) {
        money += Number(data.phone.monthAvg)
      }
      if (data.sdm) {
        money += Number(data.sdm.monthAvg)
      }
      return money.toFixed(0)
    }
  }
}
</script>
<style>
.content-board-row div {
  border: 1px solid #ddd;
  padding: 10px 10px 10px 20px;
  font-size: 14px;
}

.bold-p {
  font-weight: bold
}

.content-board-card {
  background: #eee;
  padding: 10px;
  margin: 10px;
}
.font-big-data{
  font-size: 18px;
}
</style>
